import _ from '@lodash';
import WorkflowItem from '../WorkflowItem';

export const defaultDefinition = {
	name: null,
	input_fields: [{ name: 'Components', type: 'Components', enabled: true, value: null }],
	output_fields: [{ name: 'Components', type: 'Components' }],
	feature_column: null,
	component_title: null
};

export const converter = function (data) {
	return data;
};

export default function MoleFlowToMassFlowTransformation(props) {
	return <WorkflowItem {...props} type="MOLEFLOW_TO_MASSFLOW" />;
}
